'use client';

import {IMGPW} from '@/config';
import {Link, useRouter} from '@/i18n/routing';
import {SearchProduct} from '@winelivery-org/wl-client-sdk-js/dist/models/search';
import {useTranslations} from 'next-intl';
import Image from 'next/image';
import {Button} from 'src/components/design-system';
import ProductItem from 'src/components/shop/ProductItem';
import AddressModal from '../../shop/components/commons/AddressModal/AddressModal';
import useAddressSearch from '../../shop/components/commons/AddressModal/hook';

interface MappedCategory {
  id: string;
  label: string;
  slug: string;
  title: string;
  subtitle: string;
  description: string;
  keywords: string;
}

interface Props {
  products: SearchProduct[];
  category: MappedCategory;
}

export default function DeliveryPage({products, category}: Props) {
  const t = useTranslations('delivery');

  const router = useRouter();

  const {updateGlobalLocation} = useAddressSearch('');

  return (
    <>
      <div className="section-container py-4">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-2">
            {t(category.title)}
          </h1>
          <h4 className="text-xl font-bold mb-4 text-primary">
            {t(category.subtitle)}
          </h4>
          <p className="text-balance">{t(category.description)}</p>
        </div>

        <div className="flex flex-wrap justify-center md:text-left">
          {products.map((p) => (
            <div className="w-1/2 md:w-1/3 lg:w-1/4 p-3" key={p.slug!}>
              <ProductItem
                isShowOnly={false}
                button={
                  <Link href={{pathname: '/shop/[id]', params: {id: p.slug!}}}>
                    <button className="button btn-sm leading-8 btn-primary-o m-0 product-btn">
                      {t('go-to-product')}
                    </button>
                  </Link>
                }
                key={p.id}
                product={p}
              />
            </div>
          ))}
        </div>
      </div>
      <AddressModal
        showSavedAddresses
        showLastAddress
        onChangeAddress={async (location) => {
          await updateGlobalLocation(location);
          if (category.slug === 'cocktail-kit') {
            router.push({
              pathname: `/shop`,
              query: {category: 'cocktails'},
            });
          } else {
            router.push({
              pathname: `/shop`,
              query: {category: category.slug},
            });
          }
        }}
        renderTrigger={({open}) => (
          <div className="xl:py-8 xl:bg-greyscale-gray-lighter">
            <div className="section-container bg-white rounded-lg shadow-xl">
              <div className="px-8 py-4 max-xl:pb-8">
                <div className="flex flex-wrap items-center">
                  <div className="w-full lg:w-2/3 max-lg:text-center">
                    <h2 style={{fontWeight: 'bold'}}>
                      {t('address-banner.title')}
                    </h2>
                    <h6 className="text-balance">{t('address-banner.text')}</h6>
                    <div className="mt-4">
                      <Button onClick={open}>
                        {t('address-banner.button')}
                      </Button>
                    </div>
                  </div>
                  <div className="lg:w-1/3 max-lg:hidden">
                    <Image
                      width={400}
                      height={400}
                      src={`${IMGPW}/shop_locator.png`}
                      alt={'shop locator'}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      />
    </>
  );
}
